import { render, staticRenderFns } from "./insect_info.vue?vue&type=template&id=0990fe9f&"
import script from "./insect_info.vue?vue&type=script&lang=js&"
export * from "./insect_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports